import React, { CSSProperties, useState } from "react";
import IconArrowDropRight from "../dynamicicons/icon-arrow-drop-right";
import { StatusType } from "../helper/status-helper";
import * as styles from "./velavu-expand-menu.module.scss";
import VelavuIndicator from "./velavu-indicator";
import IconArrowDropDown from "../dynamicicons/icon-arrow-drop-down";
import whitelabel from "../whitelabel";

export default function VelavuExpandMenu(props: {
	label: string;
	className?: string;
	style?: CSSProperties;
	children?: React.ReactNode;

	indicator?: StatusType;
}) {
	const [isExpanded, setExpanded] = useState(false);

	return (
		<div className={props.className} style={props.style}>
			<div
				className={`${styles.titleRow} ${
					isExpanded && props.children ? styles.openMargin : ""
				}`}
				onClick={() => setExpanded(!isExpanded)}
			>
				{isExpanded ? (
					<IconArrowDropDown
						color={whitelabel.palette.secondary700}
					/>
				) : (
					<IconArrowDropRight
						color={whitelabel.palette.secondary700}
					/>
				)}

				<span className={styles.label}>{props.label}</span>

				{props.indicator !== undefined && (
					<VelavuIndicator type={props.indicator} />
				)}
			</div>

			{isExpanded && props.children}
		</div>
	);
}
